import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../shared";
import {
  UpperbeltFilesComponent,
  UpperbeltPdfViewerComponent,
} from "./containers";
import { UpperbeltFilesRoutingModule } from "./upperbelt-files-routing.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    UpperbeltFilesRoutingModule,
  ],
  declarations: [UpperbeltFilesComponent, UpperbeltPdfViewerComponent],
  exports: [UpperbeltFilesComponent],
})
export class UpperbeltFilesModule {}
